export interface ChipProps {
	active?: boolean;
	onClick?: () => void;
	children: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

export function Chip({
	active = false,
	onClick,
	children,
	className,
	style,
}: ChipProps) {
	return (
		<button
			type="button"
			aria-pressed={active}
			onClick={onClick}
			className={className}
			style={{
				display: "inline-flex",
				alignItems: "center",
				height: 32,
				paddingLeft: 14,
				paddingRight: 14,
				fontSize: 13,
				fontFamily: "var(--font-body)",
				fontWeight: 500,
				color: active
					? "var(--color-dashboard-on-fill)"
					: "var(--color-dashboard-muted-dark)",
				background: active ? "var(--color-dashboard-accent)" : "transparent",
				border: active
					? "transparent"
					: "1px solid var(--color-dashboard-border)",
				borderRadius: 16,
				cursor: "pointer",
				transition: "all 200ms cubic-bezier(0.22,1,0.36,1)",
				...style,
			}}
		>
			{children}
		</button>
	);
}
